
import Vue from "vue";
import MapsFooter from "@/components/v-footer.vue";

export default Vue.extend({
  name: "component-power-by-vacan-frame",
  components: { MapsFooter },
});
